import { withDynamicCdn } from './utils/dynamic-cdn';

export const OCR_STATUS = {
    INIT: 0,
    SUCCESS: 1,
    FAIL: 2,
};

export const RESULT_FALLBACK_VALUE = null;


export const OCR_ICON = {
    [OCR_STATUS.INIT]: '',
    [OCR_STATUS.SUCCESS]: withDynamicCdn('kos/nlav10901/ocr-success.svg'),
    [OCR_STATUS.FAIL]: withDynamicCdn('kos/nlav10901/ocr-fail.svg'),
};

export const OCR_TYPE = {
    ID_CARD: 1,
    BUSINESS_LICENSE: 2,
    BANK_CARD: 3,
};

export const URL_IMG_OCR = '/rest/zt/collector/ocr/{bizKey}/identify';

export const NOTICE_TYPE = {
    FORM: 1,
};